<template>
  <div
    class="d-flex flex-column position-relative"
    style="z-index: 20"
  >
    <v-input
      input-id="research"
      label="Nom ou siret de l'entreprise"
      :mask="mask"
      placeholder="Rechercher"
      :debounce-timer="1000"
      :input-validation="() => null"
      :module-name="moduleName"
      :getter-name="getterName"
      :getter-function="getterFunction"
      :setter-name="setterName"
      :readonly="!research"
      :disabled="!research"
      @focus="ui_focusScreen(true && term)"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Input from '@/components/common/input/Input2.vue';

import { ui } from '@/mixins';

export default {
  name: 'CompanyAutoComplete',
  components: {
    'v-input': Input,
  },
  mixins: [ui],
  props: {
    research: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      term: 'companies/term',
    }),
    mask() {
      if (this.research) {
        return 'search';
      }
      return 'all';
    },
    moduleName() {
      return 'companies';
    },
    getterName() {
      if (this.research) {
        return 'term';
      }
      return 'company';
    },
    getterFunction() {
      if (this.research) {
        return (value) => value;
      }
      return (({ name, siret }) => `${name} - ${siret}`);
    },
    setterName() {
      if (this.research) {
        return 'setTerm';
      }
      return 'noop';
    },
  },
  watch: {
    term: {
      handler(value) {
        if (!value) { this.ui_focusScreen(false); }
      },
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.research) {
        const toFocus = document.getElementById('research');
        if (toFocus) { toFocus.focus(); }
      }
    }, 1700);
  },
};
</script>
<style scoped>
.remove-company {
  position:absolute;
  right: 0;
  bottom: 0;
  height:60px;
  width: 60px;
}
.remove-company:hover svg {
  color: var(--bs-primary)
}
</style>
